import { FC } from 'react'

interface ITicketSettings {
  title: string
  color: string
}

const ticketStatuses: Record<string, ITicketSettings> = {
  1: { title: 'Open', color: '#23BB29' },
  2: { title: 'New', color: '#337BB6' },
  3: { title: 'Pending', color: '#4891FF' },
  4: { title: 'Closed', color: '#5F7484' },
  5: { title: 'Archived', color: '#2C3034' },
}

const TicketStatus: FC<{
  statusId?: string | number
  name?: string
  isNotIcon?: boolean
  variant?: 'error' | 'warning' | 'info'
}> = ({ statusId = 1, name, isNotIcon = false, variant = 'info' }) =>
  isNotIcon ? (
    <div
      style={
        {
          error: { backgroundColor: 'white' },
          warning: { backgroundColor: ticketStatuses?.[statusId]?.color || 'grey' },
          info: { backgroundColor: ticketStatuses?.[statusId]?.color || 'grey' },
        }[variant]
      }
      className='rounded-[5px] text-white font-bold py-[1px] px-[9px] tracking-wide whitespace-nowrap text-center flex w-min'
    >
      {name || ticketStatuses?.[statusId]?.title || ' - '}
    </div>
  ) : (
    <div
      style={
        {
          error: {
            backgroundColor: 'rgb(254 226 226 )',
            color: 'rgb(127 29 29)',
            border: '1px solid rgb(127 29 29 / .5)',
          },
          warning: {
            backgroundColor: 'rgb(255 239 216)',
            color: 'rgb(195 117 16)',
            border: '1px solid rgb(255 193 105 / 1)',
          },
          info: { backgroundColor: ticketStatuses?.[statusId]?.color || 'grey' },
        }[variant]
      }
      className='rounded-[5px] text-white font-bold py-[1px] px-[9px] tracking-wide whitespace-nowrap text-center flex w-min'
    >
      {name || ticketStatuses?.[statusId]?.title || ' - '}
    </div>
  )

export default TicketStatus
